var exports = {
  "kL": "GroupInvitesModal.module__container___TUZOX1",
  "CR": "GroupInvitesModal.module__modalRoot___TUZOX1" + " " + __webpack_require__(45076)["root"] + " " + __webpack_require__(45076)["large"],
  "dc": "GroupInvitesModal.module__spinnerContainer___TUZOX1",
  "Ye": "GroupInvitesModal.module__errorBox___TUZOX1",
  "kc": "GroupInvitesModal.module__errorText___TUZOX1",
  "Zb": "GroupInvitesModal.module__stateBox___TUZOX1",
  "r9": "GroupInvitesModal.module__stateText___TUZOX1",
  "Mp": "GroupInvitesModal.module__invitesWrapper___TUZOX1",
  "$h": "GroupInvitesModal.module__invitesList___TUZOX1",
  "XG": "GroupInvitesModal.module__scroller___TUZOX1",
  "eu": "GroupInvitesModal.module__inviteItems___TUZOX1",
};

module.exports = exports;
